import React, { useState, useEffect } from "react";
import useLoginFlow from "./useLoginFlow";
import PhoneStep from "./PhoneStep";
import OtpStep from "./OtpStep";
import EmailAuthStep from "./EmailAuthStep";
import "./Login.css";

const Login = () => {
  const flow = useLoginFlow();
  const [imageLoaded, setImageLoaded] = useState(false);
  const [minDelayDone, setMinDelayDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMinDelayDone(true), 400);
    return () => clearTimeout(timer);
  }, []);

  const showImage = imageLoaded && minDelayDone;

  return (
    <div className="login-page">
      <div
        id="recaptcha-container"
        style={{ position: "fixed", bottom: 16, right: 16, zIndex: 9999 }}
      />

      <form onSubmit={(e) => e.preventDefault()} className="login-card">
        <div className="login-left-panel">
          {!flow.confirmResult && !flow.emailAuthRequired && (
            <>
              <h1 className="login-heading">Admin Login</h1>
              <p className="login-subtitle">
                Login to manage your group. You must first be registered in the app.
              </p>
            </>
          )}

          {flow.confirmResult ? (
            <OtpStep flow={flow} />
          ) : flow.emailAuthRequired ? (
            <EmailAuthStep flow={flow} />
          ) : (
            <PhoneStep flow={flow} />
          )}
        </div>

        <div className="login-right-panel">
          {!showImage && <div className="login-image-shimmer" />}
          <img
            src="/images/login.png"
            alt=""
            className={`login-right-image${showImage ? " login-right-image--loaded" : ""}`}
            onLoad={() => setImageLoaded(true)}
          />
        </div>
      </form>
    </div>
  );
};

export default Login;
